import {RetentionApiChartType, RetentionChartType, RetentionType} from 'common/report/util/retention/types';
import {ChartType as CommonChartType} from 'common/report/constants';

export const REPORT_TYPES = {
  ADDICTION: `addiction`,
  RETENTION: `retention`,
};

export enum RetentionApiChartTypes {
  Line = `line`,
  Table = `table`,
  RetentionTrend = `retention-trend`,
}

export const AGGREGATED_ROW_NAME = (reportType: RetentionType) =>
  `Average ${reportType === `addiction` ? `Frequency` : `Retention`}`;

// Map to/from bookmark format
// TODO: consider doing a pass changing API's to be consistent with our unique ChartType enums
export const COMMON_CHART_TYPE_TO_API_CHART_TYPE: {[key in RetentionChartType]: RetentionApiChartTypes} = {
  [CommonChartType.RetentionLine]: RetentionApiChartTypes.Line,
  [CommonChartType.RetentionTable]: RetentionApiChartTypes.Table,
  [CommonChartType.RetentionTrend]: RetentionApiChartTypes.RetentionTrend,
};

export const API_CHART_TYPE_TO_COMMON_CHART_TYPE: {[key in RetentionApiChartType]: RetentionChartType} = {
  // Cast any old line chart bookmarks to table
  line: CommonChartType.RetentionTable,
  table: CommonChartType.RetentionTable,
  'retention-trend': CommonChartType.RetentionTrend,
};

export enum LoadingStatus {
  Empty = `empty`,
  Loading = `loading`,
  Complete = `complete`,
  Error = `error`,
  NoData = `no-data`,
  DataClassificationError = `dataClassificationError`,
  MissingMappedDataGroup = `missingMappedDataGroup`,
  UnsupportedActionError = `unsupportedActionError`,
}
